import { API_AUTH } from ".././common";

const QuanLyCongViecApi = {
    getTasks : (params) => API_AUTH.get("api/threadwork/DanhSach", params),
    getTaskById : (id) => API_AUTH.get("api/threadwork/ChiTiet", { id }),
    createTask : (data) => API_AUTH.post("api/threadwork/CreateTask", data),
    updateTask : (id, data) => API_AUTH.put("api/threadwork/UpdateTask", data, { params: { id } }),
    deleteTask : (id) => API_AUTH.delete("api/threadwork/DeleteTask", { id }),
    evaluateTask : (id, data) => API_AUTH.post("api/threadwork/DanhGiaTask", data, { params: { id } }),
    extendTask : (id, data) => API_AUTH.post("api/threadwork/GiaHanTask", data, { params: { id } }),
    reassignTask : (id, data) => API_AUTH.post("api/threadwork/GiaoViecTask", data, { params: { id } }),
};
export default QuanLyCongViecApi;